import {
  SYS_BREAKPOINT_2_XL,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_SM,
  SYS_BREAKPOINT_XL,
  SYS_BREAKPOINT_XS,
} from '@oneaudi/unified-web-common';
import type { CustomTheme } from '../@types/theme';

const breakpoints = {
  xs: parseInt(SYS_BREAKPOINT_XS, 10),
  sm: parseInt(SYS_BREAKPOINT_SM, 10),
  md: parseInt(SYS_BREAKPOINT_MD, 10),
  lg: parseInt(SYS_BREAKPOINT_LG, 10),
  xl: parseInt(SYS_BREAKPOINT_XL, 10),
  xxl: parseInt(SYS_BREAKPOINT_2_XL, 10),
};

export const lightTheme: CustomTheme = {
  name: 'light',
  breakpoints,
  easing: 'cubic-bezier(0.75, 0.02, 0.5, 1)',
};
